<template>
  <PrimePaginator v-bind.prop="props" v-on="listeners" :pt="passThrough" />
</template>

<script setup lang="ts">
import { usePassThrough } from 'primevue/passthrough';
import PrimePaginator from 'primevue/paginator';
import { useListeners } from '../utils';
import {
  MeridiaPaginatorEmits,
  MeridiaPaginatorPassThroughValues,
  MeridiaPaginatorProps,
  PassThroughMeridiaPaginator,
} from './types';

const props = defineProps<MeridiaPaginatorProps>();

const emit = defineEmits<MeridiaPaginatorEmits>();

const passThrough = usePassThrough(
  props.pt,
  MeridiaPaginatorPassThroughValues,
  {
    mergeSections: false,
    mergeProps: true,
  }
) as PassThroughMeridiaPaginator;

const { listeners } = useListeners<MeridiaPaginatorEmits>(emit, PrimePaginator);
</script>

<style lang="scss" scoped>
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 150ms ease-out;
}
</style>
